import Hls from 'hls.js';
import EventBus, { Event } from '@/core/event-bus';
import { HlsErrorHandler, emitToClient } from '.';
import { ErrorData } from './smvp-error-handler';

export default function onManifestError(
    hls: Hls,
    eventBus: EventBus
): HlsErrorHandler {
    return (
        event: string,
        data: ErrorData
    ) => {
        if (data.fatal) {
            // This action is mostly useful for RTMPS streams where there might be no manifest to get for some reason, request will
            // receive 404s until some stream is sent to the server, which seems to trigger the creation of the manifest.
            // startLoad and recoverMediaError do not seem to request the manifest again, so we need to do it manually
            eventBus.emit(Event.reset, { timeout: 5 * 1000 });
        }

        console.warn(`[Hls] ${data?.details} encountered. Emitting to client`, { event, data });

        emitToClient(hls, eventBus, event, data);
    };
}
